<template>
  <Logs />
</template>

<script>
import Logs from '@/components/admin/logs/LogsPage.vue'

export default {
  name: 'AdministrationServerLogs',
  components: { Logs }
}
</script>

<style scoped>

</style>
